import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=5d0033d4&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=5d0033d4&prod&lang=scss&scoped=true"
import style1 from "./ProductPage.vue?vue&type=style&index=1&id=5d0033d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0033d4",
  null
  
)

export default component.exports